import { render, staticRenderFns } from "./Casting.vue?vue&type=template&id=4c8fc1e0&scoped=true&"
import script from "./Casting.vue?vue&type=script&lang=js&"
export * from "./Casting.vue?vue&type=script&lang=js&"
import style0 from "./Casting.vue?vue&type=style&index=0&id=4c8fc1e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8fc1e0",
  null
  
)

component.options.__file = "Casting.vue"
export default component.exports